export class DateRange {
  id: number;
  startDate: Date;
  endDate: Date;
}
